import moment from 'moment';

/** status 为空（null/undefined/''）视为未启动 */
export function inspectStatusIsEmpty(task) {
  const s = task && task.status;
  return s === null || s === undefined || s === '';
}

/**
 * 按 dueDate / finishDate / status 划分（与拉数口径一致）
 * - 未启动：status 为空
 * - 按时完成：有 finishDate 且 finishDate <= dueDate（日粒度，无 due 则视为按时完成）
 * - 超期完成：有 finishDate 且 finishDate > dueDate
 * - 超期未完成：无 finishDate、有 due 且当前日晚于 due
 * - 未完成：无 finishDate、未超期（含无截止日期）
 */
export function classifyInspectTask(task, nowM = moment()) {
  if (inspectStatusIsEmpty(task)) {
    return '未启动';
  }
  const due = task.dueDate ? moment(task.dueDate) : null;
  const fin = task.finishDate ? moment(task.finishDate) : null;
  const done = fin && fin.isValid();
  if (done) {
    if (!due || !due.isValid()) {
      return '按时完成';
    }
    if (fin.isAfter(due, 'day')) {
      return '超期完成';
    }
    return '按时完成';
  }
  if (due && due.isValid() && nowM.isAfter(due, 'day')) {
    return '超期未完成';
  }
  return '未完成';
}

export const INSPECT_STATUS_OPTIONS = ['未启动', '未完成', '按时完成', '超期完成', '超期未完成'];

/** 仅保留 dataDate 最近的一条跟踪（不改变其它字段） */
export function taskKeepLatestTrackingOnly(task) {
  if (!task || !task.trackings || !Array.isArray(task.trackings) || task.trackings.length <= 1) {
    return { ...task };
  }
  const sorted = [...task.trackings].sort((a, b) => {
    const da = a && a.dataDate ? moment(a.dataDate).valueOf() : 0;
    const db = b && b.dataDate ? moment(b.dataDate).valueOf() : 0;
    return db - da;
  });
  return {
    ...task,
    trackings: [sorted[0]],
  };
}
